export const CACHE_KEYS = {
    Alias: 'aliases',
    AuditCampaign: "audit-projects",
    AuditRecord: "recolement",
    Authority: 'authorities',
    Collaborator: "collaborators",
    ConditionReport: 'conditionReports',
    EntityField: 'entityField',
    Expression: 'expressions',
    Item: 'items',
    Location: 'locations',
    Manifestation: 'manifestations',
    numericMuseumItem: "items",
    physicalMuseumItem: "items",
    ThesaurusTerm: "thesaurusTerm",
    Thesaurus: "thesaurus",
    Work: 'works',
}